export const REPORT_KEYS = Object.freeze([
  "purchasingDashboard",
  "sales",
  "commissions",
  "clientInvoicing",
  "productSold",
  "documents",
  "supplier",
  "arAging",
  "workInProgress",
]);

export const DEFAULT_REPORT_KEY = "purchasingDashboard";
export const REPORT_KEY_SET = new Set(REPORT_KEYS);

export const normalizeReportKey = (value, fallback = null) => {
  if (value == null || String(value).trim() === "") return fallback;
  const normalized = String(value).trim();
  return REPORT_KEY_SET.has(normalized) ? normalized : null;
};
